import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { State } from 'store'
import { User } from 'auth/state'
import { BaseRouteParams } from 'hocs'
import { isConviousAdmin as getIsConviousAdmin, isPartnerAdmin as getIsPartnerAdmin } from 'utils/useGetPermission'
import { useHasFeatureFunc } from 'utils/useHasFeature'
import { UnderlineNavigationTabs } from 'uiComponents/navigation/underlineNavigationTabs'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'
import { useHasAnyIntegrations } from './integrations/utils'

function SettingsSectionTabs() {
    const { accountSlug } = useParams<BaseRouteParams>()
    const location = useLocation()
    const history = useHistory()
    const hasFeature = useHasFeatureFunc()
    const hasAnyIntegrations = useHasAnyIntegrations()
    const user = useSelector((state: State) => state.auth.user)
    const activeAccount = useSelector((state: State) => state.preferences.activeAccount)
    const isConviousAdmin = getIsConviousAdmin(user as User, activeAccount)
    const isPartnerAdmin = getIsPartnerAdmin(user as User, activeAccount)

    const accountSettings = `/account/${accountSlug}/settings/account_settings`
    const inSection = (fragment: string) => location.pathname.includes(fragment)

    const tabs = [
        { name: 'Account', path: `${accountSettings}/account_info`, activeKey: 'account_info', shouldShow: true },
        {
            name: 'Payment Methods',
            path: `${accountSettings}/payment_methods`,
            activeKey: 'payment_methods',
            shouldShow: true,
        },
        {
            name: 'Fees',
            path: `${accountSettings}/booking_fees`,
            activeKey: 'fees',
            shouldShow: hasFeature('BookingFees'),
        },
        {
            name: 'Tax Configurations',
            path: `${accountSettings}/tax_configurations`,
            activeKey: 'tax_configurations',
            shouldShow: hasFeature('TaxConfigurations'),
        },
        {
            name: 'Reporting Categories',
            path: `${accountSettings}/reporting_categories`,
            activeKey: 'reporting_categories',
            shouldShow: hasFeature('ReportingCategories'),
        },
        { name: 'Contract', path: `${accountSettings}/contract`, activeKey: 'contract', shouldShow: isConviousAdmin },
        {
            name: 'Integrations',
            path: `${accountSettings}/integrations`,
            activeKey: 'integrations',
            shouldShow: (isPartnerAdmin && hasAnyIntegrations) || isConviousAdmin,
        },
        {
            name: 'Users',
            path: `/account/${accountSlug}/settings/users/user_list`,
            activeKey: '/settings/users',
            shouldShow: true,
        },
        {
            name: 'Script',
            path: `/account/${accountSlug}/settings/add_snippet`,
            activeKey: '/settings/add_snippet',
            shouldShow: true,
        },
    ]
        .filter((tab) => tab.shouldShow)
        .map((tab) => ({
            name: tab.name,
            current: inSection(tab.activeKey),
            href: tab.path,
            onClick: () => history.push(tab.path),
        }))

    if (tabs.length < 2) {
        return null
    }

    return (
        <InSectionTabsSlot>
            <UnderlineNavigationTabs tabs={tabs} />
        </InSectionTabsSlot>
    )
}

export default SettingsSectionTabs
